import React, { useState,useEffect} from "react";
import Sidebar from "../components/Sidebar";
 import Header from "../components/Header";
 import { Outlet } from "react-router-dom";
 
const MainLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1200) {  // 모바일 화면 기준
        setIsMobile(true);
        setSidebarOpen(false);  // 모바일에서 화면 크기 조정 시 사이드바를 기본으로 닫음
      } else {
        setIsMobile(false);
        setSidebarOpen(true);  // 데스크탑에서는 사이드바 항상 열려있음
      }
    };

    // 초기 화면 크기 체크
    handleResize();

    // 화면 크기 변경 이벤트 리스너
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  
  return (

  
    <div className="main">
      {
      <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} />}
      <div className="layout-wrapper">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} isMobile={isMobile} />
    <div className="layout-content scrollable-content" >
        <Outlet /> {/* <- 여기 꼭 있어야 함! */}
      </div>
    </div>
    </div>
  );
};

export default MainLayout;